import {useEffect, useState} from 'react';

import {useViewSpecQuery} from '../../generated/graphql';
import {useApolloClient} from '../../state/hooks';
import {parsedReportSpec, type SlateReport} from './';

export function useParsedReportSpec(reportID: string): SlateReport | undefined {
  const client = useApolloClient();
  const {data: viewQueryData} = useViewSpecQuery({variables: {id: reportID}});
  const [parsedSpec, setParsedSpec] = useState<SlateReport | undefined>(
    undefined
  );

  useEffect(() => {
    async function parseSpec() {
      const spec = viewQueryData?.view?.spec;
      if (!spec) {
        return;
      }

      const viewType = viewQueryData?.view?.type;
      if (viewType !== 'runs' && viewType !== 'runs/draft') {
        console.error('Invalid view type for report:', viewType);
        return;
      }

      const parsed = await parsedReportSpec(JSON.parse(spec), viewType, client);
      setParsedSpec(parsed);
    }
    parseSpec();
  }, [viewQueryData, client]);

  return parsedSpec;
}
